<template>  
    <v-card
        class="not-yet-implemented-card"
        color="#1A3A3B"
        text-color="white"
        outlined
        style="max-width: 600px; margin: auto; margin-top: 50px;"
    >
        <v-card-title class="headline">
            {{ $t('notYetImplemented') }}
        </v-card-title>
        <v-card-text>
            {{ $t('notYetImplementedText') }}
        </v-card-text>
        <v-card-actions>
            <v-btn color="secondary" @click="$router.push('/')">
                {{ $t('goBack') }}
            </v-btn>
        </v-card-actions>
    </v-card>        
</template>